
<div class="main-page-content">
  <div class="main-page-content-block" *ngIf="!currentItem">
    <h1 class="content-heading-font">{{ currentClient?.BusinessName ||'Client' }} AI Usage Limits</h1>
    <div class="div-loading">Loading client AI usage limits...</div>
  </div>
  <div class="main-page-content-block" *ngIf="currentItem">
    <h2>{{ currentClient?.BusinessName ||'Client' }} AI Usage Limits</h2>
    <p class="alert alert-info">
      Limits are shared across all AI use in this company. Leave a field blank to block AI use for that period. Enter 0 for unlimited use.
    </p>

    <div class="row">
      <div class="col-lg-4 mb-3">
        <label for="DailyUsdLimit">Daily USD limit</label>
        <input id="DailyUsdLimit" name="DailyUsdLimit" type="number" min="0" step="0.01" class="form-control"
               [(ngModel)]="currentItem.DailyUsdLimit" />
      </div>
      <div class="col-lg-4 mb-3">
        <label for="WeeklyUsdLimit">Weekly USD limit</label>
        <input id="WeeklyUsdLimit" name="WeeklyUsdLimit" type="number" min="0" step="0.01" class="form-control"
               [(ngModel)]="currentItem.WeeklyUsdLimit" />
      </div>
      <div class="col-lg-4 mb-3">
        <label for="MonthlyUsdLimit">Monthly USD limit</label>
        <input id="MonthlyUsdLimit" name="MonthlyUsdLimit" type="number" min="0" step="0.01" class="form-control"
               [(ngModel)]="currentItem.MonthlyUsdLimit" />
      </div>
    </div>

    <p class="text-muted">
      Prices for each model are set on the <a [routerLink]="aiModelPricingLink">AI Model Pricing</a> screen.
      Each company chooses which priced models its features use in OptoMiser, under General Settings &gt; AI features.
    </p>

    <button class="btn btn-success" [class.button-loading]="loading" (click)="save()">Save</button>
  </div>
</div>
